import React from 'react';
import { IActionRowList } from './ActionRowList.types';
import * as Styles from './ActionRowList.styles';

const ActionRowList: React.FC<IActionRowList> = ({
  hasDividers = true,
  spacing = 'default',
  children,
  ...otherProps
}: IActionRowList) => {
  return (
    <Styles.ActionRowSpacedBottom hasDividers={hasDividers} spacing={spacing} {...otherProps} role="list">
      {children}
    </Styles.ActionRowSpacedBottom>
  );
};

ActionRowList.displayName = 'ActionRowList';
export default ActionRowList;
